import { render, staticRenderFns } from "./FullscreenNavigation.vue?vue&type=template&id=f9a583ca&"
import script from "./FullscreenNavigation.vue?vue&type=script&lang=js&"
export * from "./FullscreenNavigation.vue?vue&type=script&lang=js&"
import style0 from "./FullscreenNavigation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports